module.exports = __webpack_public_path__ + "static/media/2018.e9fc9141.jpg";